// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb-48[data-v-1ec3a4c0]{margin-bottom:48px}.router-link-wrapper[data-v-1ec3a4c0]{text-align:center;margin-top:10px}.router-link-wrapper .router-link[data-v-1ec3a4c0]{text-decoration:none}", ""]);
// Exports
module.exports = exports;
